import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {     
        id       : 'home',
        title    : 'Home',
        translate: 'NAV.HOME.TITEL',
        type     : 'collapsable',
        icon     : 'home',
        url      : '/home'
    }, 
    {     
        id       : 'homeklant',
        title    : 'Home',
        translate: 'NAV.HOMEKLANT.TITEL',
        type     : 'collapsable',
        icon     : 'home',
        url      : '/homeklant'
    }, 
    {
                id       : 'medewerkers',
                title    : 'Medewerkers',
                translate: 'NAV.MEDEWERKERS.TITEL',
                type     : 'collapsable',
                icon     : 'email',
                children : [
                    {
                        id       : 'overzicht',
                        title    : 'Overzicht',
                        translate: 'NAV.MEDEWERKERS.OVERZICHT',
                        type     : 'item',
                        icon     : 'email',
                        url      : '/medewerkers/overzicht',

                    }
                ]
            },
            {     
                id       : 'planning',
                title    : 'Planning',
                translate: 'NAV.PLANNING.TITEL',
                type     : 'collapsable',
                icon     : 'email',
                children : [
                    {
                        id       : 'planningoverzicht',
                        title    : 'Overzicht Medewerkers',
                        translate: 'NAV.PLANNING.OVERZICHT',
                        type     : 'item',
                        icon     : 'email',
                        url      : '/planning/overzicht',

                    },
                    {     
                        id       : 'planningsimpel',
                        title    : 'Overzicht Medewerker',
                        translate: 'NAV.PLANNINGSIMPEL.TITEL',
                        type     : 'item',
                        icon     : 'email',
                        url      : '/planning/overzichtsimpel'
                    },
                    {     
                        id       : 'planningsimpelKlant',
                        title    : 'Overzicht Klant',
                        translate: 'NAV.PLANNINGSIMPELKLANT.TITEL',
                        type     : 'item',
                        icon     : 'email',
                        url      : '/planning/overzichtsimpelklant'
                    }
                ]
            },
            {     
                id       : 'buitendienst',
                title    : 'Buitendienst',
                translate: 'NAV.BUITENDIENST.TITEL',
                type     : 'collapsable',
                icon     : 'email',
                children : [
                    {
                        id       : 'werkbon',
                        title    : 'Werkbon',
                        translate: 'NAV.BUITENDIENST.WERKBON',
                        type     : 'item',
                        icon     : 'email',
                        url      : '/buitendienst/werkbon',

                    }
                ]
            },               
    
           
];
